import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

import Text from '~/common/components/Texts/Text';
import type { LoanSummary } from '~/common/hooks/useGetLoanSummary';
import Grid from '~/common/mui/Grids/GridItem';
import lang from '~/modals/LoanSummaryDialog/language.json';

import { LabelText, SpacedRow, StyledDivider, TopLabel } from './Styled';

type LoanSummaryDatesTabProps = Readonly<{
  loanSummaryDates: LoanSummary['loanSummaryDates'];
}>;

function formatDate(date?: Dayjs) {
  return date?.isValid() && !date.isSame(dayjs('12/31/1969'))
    ? date.format('M/D/YYYY')
    : lang.PLACEHOLDER;
}

export function LoanSummaryDatesTab({
  loanSummaryDates,
}: LoanSummaryDatesTabProps) {
  return (
    <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'row' }}>
      <Grid
        id="dates-details"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          mt: '1rem',
          minWidth: '340px',
          mr: '1.5rem',
        }}
      >
        <TopLabel>{lang.DATES}</TopLabel>
        <SpacedRow>
          <LabelText>{lang.TEN_ZERO_THREE_SIGNATURE_DATE}</LabelText>
          <Text>{formatDate(loanSummaryDates.loanApplicationDate)}</Text>
        </SpacedRow>
        <StyledDivider />
        <SpacedRow>
          <LabelText>{lang.APPROVAL_EXPIRATION}</LabelText>
          <Text>{formatDate(loanSummaryDates.approvalExpirationDate)}</Text>
        </SpacedRow>
        <StyledDivider />
        <SpacedRow>
          <LabelText>{lang.LOCK_EXPIRATION}</LabelText>
          <Text>{formatDate(loanSummaryDates.lockExpirationDate)}</Text>
        </SpacedRow>
        <StyledDivider />
        <SpacedRow>
          <LabelText>{lang.ESTIMATED_CLOSING}</LabelText>
          <Text>{formatDate(loanSummaryDates.estimatedClosingDate)}</Text>
        </SpacedRow>
        <StyledDivider />
        <SpacedRow>
          <LabelText>{lang.ACTUAL_CLOSING}</LabelText>
          <Text>{formatDate(loanSummaryDates.actualClosingDate)}</Text>
        </SpacedRow>
        <StyledDivider />
        <SpacedRow>
          <LabelText>{lang.DISBURSEMENT}</LabelText>
          <Text>{formatDate(loanSummaryDates.disbursementDate)}</Text>
        </SpacedRow>
        <StyledDivider />
        <SpacedRow>
          <LabelText>{lang.FIRST_PAYMENT}</LabelText>
          <Text>{formatDate(loanSummaryDates.firstPaymentDate)}</Text>
        </SpacedRow>
        <StyledDivider />
        <SpacedRow>
          <LabelText>{lang.MATURITY}</LabelText>
          <Text>{formatDate(loanSummaryDates.maturityDate)}</Text>
        </SpacedRow>
        <StyledDivider />
        <SpacedRow>
          <LabelText>{lang.SUBMITTED_TO_UM}</LabelText>
          <Text>{formatDate(loanSummaryDates.underwritingSubmittedDate)}</Text>
        </SpacedRow>
      </Grid>
    </Grid>
  );
}
